import { DateTime } from "luxon";

export function toLocaleClockTimeString(dateTime: DateTime) {
  return dateTime.toLocaleString({ hour: "numeric", minute: "numeric" });
}
